import { useEffect } from 'react'
import { Outlet, useParams, useNavigate } from 'react-router-dom'
import TransportationAgreementModal from './TransportationAgreementModal'
import DashboardContainer from '../common/DashboardContainer'
import CarpoolNav from './CarpoolNav'
import useStore from '../../store'
import BackButton from '../common/BackButton'

export default function TransportationLayout() {
  const { dealer, user, fetchDealer } = useStore()
  const { dealerId: dealerIdParam } = useParams()
  const navigate = useNavigate()
  const targetDealerId = dealerIdParam || user?.dealerId

  useEffect(() => {
    if (!targetDealerId) return
    if (!dealer || String(dealer.id) !== String(targetDealerId)) {
      fetchDealer(targetDealerId)
    }
  }, [targetDealerId])

  if (!dealer) return null

  const signed = dealer.attributes?.['transportation-agreement-signed-at']

  return (
    <>
      {!signed && !dealerIdParam && <TransportationAgreementModal />}
      <DashboardContainer>
        {dealerIdParam && (
          <div className="h-8 mb-2">
            <BackButton
              styles="w-fit text-grey-300 hover:text-grey-100"
              label={`Back to ${dealer.attributes?.name || 'Dealer'}`}
              onClick={() => navigate(`/dealers/${dealerIdParam}`)}
            />
          </div>
        )}
        <CarpoolNav />
        <Outlet />
      </DashboardContainer>
    </>
  )
}
